(function(){
  var root=document.getElementById('pdpRoot');
  if(!root){return;}
  var notifyForced=root.getAttribute('data-notify-forced')==='true';
  var handle=root.getAttribute('data-handle')||'';
  var sel=document.getElementById('pdpVariants'),
      pills=document.querySelectorAll('.pill');
  var nb=document.getElementById('notifyBlock');
  if(nb && location.search.indexOf('customer_posted=true')>-1){nb.hidden=false;}

  /* ---------- Notify Me: tag the customer for this option (variant) or the whole product ---------- */
  var nf=document.getElementById('notifyForm');
  var nTags=nf && nf.querySelector('input[name="contact[tags]"]');
  var nLabel=document.getElementById('notifyVariantLabel');
  function curOpt(){return sel && sel.options[sel.selectedIndex];}
  function refreshNotify(){var o=curOpt();if(nLabel && o){nLabel.textContent=o.textContent.trim();}}
  refreshNotify();
  if(nf && nTags){
    nf.addEventListener('submit',function(){
      var scope=nf.querySelector('input[name="notify_scope"]:checked');
      var o=curOpt();
      if(scope && scope.value==='variant' && o){nTags.value='notify-me, notify-v-'+o.value;}
      else{nTags.value='notify-me, notify-'+handle;}
    });
  }

  /* ---------- Gallery: thumbnails, arrows, swipe, design filter ---------- */
  var main=document.getElementById('pdpMain');
  var thumbs=[].slice.call(document.querySelectorAll('.pdp-thumb'));
  var arrows=[].slice.call(document.querySelectorAll('.pdp-arrow'));
  var frame=document.querySelector('.pdp-main');
  function base(u){return (u||'').split('?')[0];}
  function visible(){return [].slice.call(document.querySelectorAll('.pdp-thumb')).filter(function(t){return !t.hidden;});}
  function show(t){
    if(!t){return;}
    if(main){main.src=t.getAttribute('data-full');var a=t.getAttribute('data-alt');if(a){main.alt=a;}}
    thumbs.forEach(function(x){x.classList.remove('on');});
    t.classList.add('on');
    var c=t.parentNode;
    if(c && c.scrollWidth>c.clientWidth){c.scrollLeft=t.offsetLeft-(c.clientWidth-t.offsetWidth)/2;}
    var v=visible(),i=v.indexOf(t);
    [v[i+1],v[i-1]].forEach(function(n){if(n){(new Image()).src=n.getAttribute('data-full');}});
  }
  function findByUrl(url){
    if(!url){return null;}
    var b=base(url),v=visible();
    for(var i=0;i<v.length;i++){if(base(v[i].getAttribute('data-full'))===b){return v[i];}}
    return null;
  }
  function step(d){
    var v=visible();
    if(v.length<2){return;}
    var i=0;
    for(var k=0;k<v.length;k++){if(v[k].classList.contains('on')){i=k;break;}}
    show(v[(i+d+v.length)%v.length]);
  }
  function refreshArrows(){
    var off=visible().length<2;
    arrows.forEach(function(a){a.classList.toggle('is-off',off);});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){show(t);});});
  arrows.forEach(function(a){a.addEventListener('click',function(){step(a.classList.contains('next')?1:-1);});});
  if(frame){
    var sx=0,sy=0,tracking=false;
    frame.addEventListener('touchstart',function(e){
      if(e.touches.length!==1){tracking=false;return;}
      tracking=true;sx=e.touches[0].clientX;sy=e.touches[0].clientY;
    },{passive:true});
    frame.addEventListener('touchend',function(e){
      if(!tracking){return;}
      tracking=false;
      var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.4){step(dx<0?1:-1);}
    },{passive:true});
  }

  /* Design option -> only show photos for that design. Photos whose alt text mentions
     no design (detail shots, etc.) stay visible for every design. */
  /* Back pocket designs (joggers): photos whose description says "printed" or "plain pocket". */
  thumbs.forEach(function(t){
    if(t.getAttribute('data-tag')){return;}
    var al=(t.getAttribute('data-alt')||'').toLowerCase();
    if(al.indexOf('printed')>-1){t.setAttribute('data-tag','printed');}
    else if(al.indexOf('plain pocket')>-1){t.setAttribute('data-tag','plain');}
  });
  var designIdx=-1,hasTags=thumbs.some(function(t){return t.getAttribute('data-tag');});
  var opts=document.querySelectorAll('.opt');
  for(var i=0;i<opts.length;i++){if((opts[i].getAttribute('data-name')||'').toLowerCase()==='design'){designIdx=i;}}
  function designKey(v){
    v=(v||'').toLowerCase();
    if(v.indexOf('printed')>-1){return 'printed';}
    if(v.indexOf('reset')>-1){return 'reset';}
    if(v.indexOf('fogd')>-1){return 'fogd';}
    if(v.indexOf('plain')>-1||v.indexOf('left logo')>-1){return 'plain';}
    return '';
  }
  /* Colour option -> jump to the first photo of that colour. All photos stay in the strip. */
  var colIdx=-1;
  for(var j=0;j<opts.length;j++){var nm=(opts[j].getAttribute('data-name')||'').toLowerCase();if(nm==='colour'||nm==='color'){colIdx=j;}}
  var COLS=['claret','black','sand','biscuit'];
  function colourOf(txt){
    txt=(txt||'').toLowerCase();var f='',n=0;
    COLS.forEach(function(c){if(txt.indexOf(c)>-1){f=c;n++;}});
    return n===1?f:'';
  }
  thumbs.forEach(function(t){t.colourTag=colourOf(t.getAttribute('data-alt'));});
  var hasColTags=colIdx>-1 && thumbs.some(function(t){return t.colourTag;});
  function chosenColour(){
    if(colIdx<0){return '';}
    var on=opts[colIdx].querySelector('.pill.on');
    return on?colourOf(on.getAttribute('data-val')):'';
  }
  var strip=thumbs.length?thumbs[0].parentNode:null;
  thumbs.forEach(function(t,n){t.origIdx=n;});
  function applyFilter(dkey,ckey,url){
    /* Design: hide only the other designs' back photos; everything else stays. */
    thumbs.forEach(function(t){
      var g=t.getAttribute('data-tag');
      t.hidden=!!(dkey && g && g!==dkey);
    });
    if(!visible().length){thumbs.forEach(function(t){t.hidden=false;});}
    /* Put the chosen design's own photo first (Reset / fogd. back); Plain keeps the natural order. */
    if(strip){
      var pri=(dkey && dkey!=='plain')?dkey:'';
      thumbs.slice().sort(function(x,y){
        var px=(pri && x.getAttribute('data-tag')===pri)?0:1;
        var py=(pri && y.getAttribute('data-tag')===pri)?0:1;
        return px-py||x.origIdx-y.origIdx;
      }).forEach(function(t){strip.appendChild(t);});
    }
    /* Colour: keep every photo, jump to the first photo of the chosen colour. */
    var pref=null;
    if(ckey){for(var q=0;q<thumbs.length;q++){if(thumbs[q].colourTag===ckey && !thumbs[q].hidden){pref=thumbs[q];break;}}}
    var own=null;
    if(dkey && dkey!=='plain'){var vv=visible();for(var z=0;z<vv.length;z++){if(vv[z].getAttribute('data-tag')===dkey){own=vv[z];break;}}}
    show(own||findByUrl(url)||pref||visible()[0]);
    refreshArrows();
  }
  function chosenDesign(){
    if(designIdx<0){return '';}
    var on=opts[designIdx].querySelector('.pill.on');
    return on?designKey(on.getAttribute('data-val')):'';
  }
  var vmap={};
  try{vmap=JSON.parse(document.getElementById('pdpVariantImages').textContent||'{}');}catch(e){}
  var useDesign=designIdx>-1 && hasTags;
  var lastKey='',lastCol='',lastUrl='';
  if(useDesign || hasColTags){
    lastKey=useDesign?chosenDesign():'';
    lastCol=hasColTags?chosenColour():'';
    lastUrl=(sel&&vmap[sel.value])||'';
    applyFilter(lastKey,lastCol,lastUrl);
  }else{
    refreshArrows();
  }

  /* ---------- Quantity ---------- */
  var qi=document.querySelector('.qty input'),
      qm=document.querySelector('.qminus'),
      qp=document.querySelector('.qplus');
  if(qm){qm.addEventListener('click',function(){qi.value=Math.max(1,(parseInt(qi.value,10)||1)-1);});}
  if(qp){qp.addEventListener('click',function(){qi.value=(parseInt(qi.value,10)||1)+1;});}

  /* ---------- Option pills -> variant ---------- */
  if(sel && pills.length){
    pills.forEach(function(p){
      p.addEventListener('click',function(){
        var group=p.getAttribute('data-opt');
        document.querySelectorAll('.pill[data-opt="'+group+'"]').forEach(function(x){x.classList.remove('on');});
        p.classList.add('on');
        var chosen=[];
        document.querySelectorAll('.opt').forEach(function(o){
          var on=o.querySelector('.pill.on');
          if(on){chosen.push(on.getAttribute('data-val'));}
        });
        var target=chosen.join(' / ');
        Array.prototype.forEach.call(sel.options,function(o){
          if(o.textContent.trim()===target){
            sel.value=o.value;
            refreshNotify();
            var btn=document.querySelector('.pdp-add');
            var avail=o.getAttribute('data-available')==='true';
            if(btn){btn.disabled=!avail;btn.innerHTML=(avail?'Add to bag':'Sold out')+' <span class="arr">&rarr;</span>';}
            if(nb && !notifyForced){nb.hidden=avail;}
            var url=vmap[o.value]||'';
            var key=useDesign?chosenDesign():'',col=hasColTags?chosenColour():'';
            if((useDesign||hasColTags) && (key!==lastKey||col!==lastCol)){applyFilter(key,col,url);}
            else if(url && url!==lastUrl){
              var t=findByUrl(url);
              if(t){show(t);}else if(main){main.src=url;}
            }
            lastKey=key;lastCol=col;
            lastUrl=url;
          }
        });
      });
    });
  }

  /* ---------- Size guide pop-up ---------- */
  var sg=document.getElementById('sgModal');
  if(sg){
    document.body.appendChild(sg);
    var opener=null;
    var openSg=function(e){
      opener=e&&e.currentTarget;
      sg.classList.add('open');document.body.classList.add('sg-lock');
      var c=sg.querySelector('.sg-close');if(c){c.focus();}
    };
    var closeSg=function(){
      sg.classList.remove('open');document.body.classList.remove('sg-lock');
      if(opener){opener.focus();}
    };
    document.querySelectorAll('[data-sg-open]').forEach(function(b){b.addEventListener('click',openSg);});
    sg.addEventListener('click',function(e){if(e.target===sg||e.target.closest('[data-sg-close]')){closeSg();}});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sg.classList.contains('open')){closeSg();}});
  }
})();